<div
  class="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8"
>
  <div
    class="max-w-4xl w-full space-y-8 bg-white py-16 px-5 md:px-10 rounded-xl shadow-lg"
  >
    <!-- Success Icon -->
    <div class="text-center">
      <div
        class="mx-auto p-4 bg-green-200 flex justify-center items-center rounded-full w-fit h-fit mb-4"
      >
        <div
          class="flex items-center justify-center h-24 w-24 shadow-sm rounded-full bg-green-500"
        >
          <svg
            class="size-12 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 13l4 4L19 7"
            ></path>
          </svg>
        </div>
      </div>
      <h2 class="text-3xl font-extrabold text-gray-900 mb-2">
        Payment Successful!
      </h2>
      <p class="text-sm text-gray-500 mb-8">
        Transaction ID: {{ transactionId }}
      </p>
    </div>

    <!-- Message -->
    <div class="text-center space-y-4">
      <p class="text-lg text-gray-700">
        Thank you for your payment. Your ad will be reviewed shortly.
      </p>
      <p class="text-sm text-gray-600">
        Your ad will be live once it has been approved by our team.
      </p>
    </div>

    <!-- Contact Info -->
    <div class="mt-8 bg-gray-50 rounded-lg p-6">
      <h3 class="text-md font-medium text-gray-900 mb-3">Need assistance?</h3>
      <p class="text-sm text-gray-600 mb-2">
        Contact our support team at:
        <a
          href="mailto:contact@onlyusedtesla.com"
          class="text-blue-600 hover:text-blue-800 font-medium"
        >
          contact&#64;onlyusedtesla.com
        </a>
      </p>
      <p class="text-sm text-gray-600">
        Our team typically responds within 24 hours.
      </p>
    </div>

    <!-- Action Buttons -->
    <div class="flex gap-4 mt-8">
      <button
        (click)="goToHome()"
        class="flex-1 bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 cursor-pointer"
      >
        Return To Dashboard
      </button>
      <button
        (click)="viewListing()"
        class="flex-1 bg-blue-600 py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 cursor-pointer"
      >
        View Listing
      </button>
    </div>
  </div>
</div>
